import type { Favorite } from "@/shared/api/types";

/** Builds the in-app route a favorite should deep-link to, per target type. */
export const favoriteLink = (f: Favorite): string => {
  switch (f.targetType) {
    case "EXAM_BOOK":
      return `/packages/${f.packageId}/exams/${f.packageExamId}/books/${f.targetId}`;
    case "LECTURE_BOOK":
      // Sınav bağlamı kitabı → sınav rotası; ders bağlamı kitabı → ders rotası (backend hangisini
      // dolduruyorsa: packageExamId ya da courseId).
      return f.packageExamId
        ? `/packages/${f.packageId}/exams/${f.packageExamId}/lecture-books/${f.targetId}`
        : `/packages/${f.packageId}/courses/${f.courseId}/lectures/${f.targetId}`;
    case "PACKAGE_EXAM":
      return `/packages/${f.packageId}/exams/${f.targetId}`;
    case "COURSE":
      return `/packages/${f.packageId}/courses/${f.targetId}`;
    case "COURSE_LECTURES":
      return `/packages/${f.packageId}/courses/${f.targetId}/lectures`;
    case "COURSE_QUESTION_BANK":
      return `/packages/${f.packageId}/courses/${f.targetId}/books?type=QUESTION_BANK`;
    case "COURSE_SCREENING_TEST":
      return `/packages/${f.packageId}/courses/${f.targetId}/books?type=SCREENING_TEST`;
  }
};
